export const environment = {
	production: false,
	apiUrl: "https://europe-west1-matchie-dev.cloudfunctions.net",
	region: "europe-west1",
	APP_URL: "https://dev.admin.matchie.co.za",
	MEMBERS_APP_URL: "https://dev.assessments.matchie.co.za",
	firebase: {
		apiKey: "AIzaSyD3DkVSEpff6jXZm7TGZWOaF1I74BDBcxY",
		authDomain: "matchie-dev.firebaseapp.com",
		projectId: "matchie-dev",
		storageBucket: "matchie-dev.firebasestorage.app",
		messagingSenderId: "644685545803",
		appId: "1:644685545803:web:945f666529fb333083a8ce",
	},
	recaptcha: {
		siteKey: "6LcCyZQsAAAAACXB5wgiS3g65huPbXHXCcn5gVuv",
		version: "enterprise",
	},
};
